import axios from 'axios';
const {REACT_APP_SERVER_URL} = process.env;

const jwtAxios = axios.create({
  baseURL: REACT_APP_SERVER_URL, //YOUR_API_URL HERE
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: '0',
  },
});

jwtAxios.defaults.headers.common['Accept'] = 'application/json';
jwtAxios.interceptors.response.use(
  (res) => res,
  async (err) => {
    const originalConfig = err.config;

    if (originalConfig.url !== '/signin' && err.response) {
      // Access Token was expired
      if (err.response.status === 401 && !originalConfig._retry) {
        originalConfig._retry = true;

        try {
          const rs = await jwtAxios.post('/auth/refresh', {
            refreshToken: localStorage.getItem('refreshToken'),
          });
          const {token} = rs.data;
          originalConfig.headers.authorization = token;
          setAuthToken(token);
          return jwtAxios(originalConfig);
        } catch (_error) {
          localStorage.removeItem('token');
          localStorage.removeItem('refreshToken');
          window.location.href = '/signin';
        }
      }

      return Promise.reject(err);
    }

    return Promise.reject(err);
  },
);
export const setAuthToken = (token) => {
  if (token) {
    jwtAxios.defaults.headers.common['authorization'] = token;
    localStorage.setItem('token', token);
  } else {
    delete jwtAxios.defaults.headers.common['authorization'];
    localStorage.removeItem('token');
  }
};

export default jwtAxios;
